import { FaUserPen } from "react-icons/fa6";
import { HiMiniDocumentArrowDown } from "react-icons/hi2";
import { IoIosFolder } from "react-icons/io";
import {
  MdDashboard,
  MdNotificationsActive,
  MdOutlineTaskAlt,
} from "react-icons/md";
import { RiOrganizationChart } from "react-icons/ri";
import { TbDeviceDesktopCog } from "react-icons/tb";
import { StickerIcon } from "./Icon";

export const MESSAGE_STATUS = {
  CREATE_GROUP: "CREATE_GROUP",
  RENAME_GROUP: "RENAME_GROUP",
  NEW_MEMBER: "NEW_MEMBER",
  TEXT: "TEXT",
  IMAGE: "IMAGE",
  FILE: "FILE",
  CHUNK: "CHUNK",
  REMOVE_MEMBER: "REMOVE_MEMBER",
  EXIT_GROUP: "EXIT_GROUP",
  UPDATE_ROLE_ADMIN: "UPDATE_ROLE_ADMIN",
  DELETE_GROUP: "DELETE_GROUP",
  UPDATE_GROUP_AVATAR: "UPDATE_GROUP_AVATAR",
  DISABLE_GROUP: "DISABLE_GROUP",
  ENABLE_GROUP: "ENABLE_GROUP",
  REMOVE_MESSAGE: "REMOVE_MESSAGE",
  SHARE_MESSAGE: "SHARE_MESSAGE",
  REACTION_MESSAGE: "REACTION_MESSAGE",
  PINNED_MESSAGE: "PINNED_MESSAGE",
  UNPINNED_MESSAGE: "UNPINNED_MESSAGE",
  PROMOTED_MESSAGE: "PROMOTED_MESSAGE",
  VIDEO: "VIDEO",
  AUDIO: "AUDIO",
  RENAME_PERSONAL_GROUP: "RENAME_PERSONAL_GROUP",
  CREATE_PERSONAL: "CREATE_PERSONAL",
  CREATE_SELF: "CREATE_SELF",
  SEEN_MESSAGE: "SEEN_MESSAGE",
  TYPING: "TYPING",
  SYSTEM_MESSAGE: "SYSTEM_MESSAGE",
  ERROR: "ERROR",
  VOTE_MESSAGE: "VOTE_MESSAGE",
  CREATE_VOTE_MESSAGE: "CREATE_VOTE_MESSAGE",
  SCHEDULE: "SCHEDULE",
  UPDATE_SCHEDULE: "UPDATE_SCHEDULE",
  DELETE_SCHEDULE: "DELETE_SCHEDULE",
  USER_STATUS_CHANGED: "USER_STATUS_CHANGED",
  STICKER: "STICKER",
  MARK_READ: "MARK_READ",
  REACTION_PREVIEW: "REACTION_PREVIEW",
};

export const role = {
  HOST: "HOST",
  MEMBER: "MEMBER",
  ADMIN: "ADMIN",
};
export const FILE_STATUS = {
  PAUSE: "PAUSE",
  READY: "READY",
  CANCEL: "CANCEL",
  ERROR: "ERROR",
  SUCCESS: "SUCCESS",
};

export const notificationMessage = {
  setMessage: (userName, newGroupName) => {
    const content = userName + " changed the group name to " + newGroupName;
    return content;
  },

  exitGroup: (userName) => {
    const content = userName + " has left the group";
    return content;
  },
};

export const organizationType = {
  PERSON: "PERSON",
  INSTITUTION: "INSTITUTION",
};

export const conversationStatus = {
  ACTIVE: "ACTIVE",
  INACTIVE: "INACTIVE",
};

export const conversationType = {
  PERSONAL: "PERSONAL",
  SELF: "SELF",
  GROUP: "GROUP",
  SYSTEM: "SYSTEM",
  NOTIFICATION: "NOTIFICATION",
  CREATE_NOTIFICATION: "CREATE_NOTIFICATION",
  CONVERSATION: "CONVERSATION",
  DRAFT: "DRAFT",
  SCHEDULE: "SCHEDULE",
  FREE: "FREE",
  STICKER: "STICKER",
};

export const conversationTab = {
  /** normal */
  ALL: "ALL",
  UNREAD: "UNREAD",
  CHAT: "CHAT",
  NOTICE: "NOTICE",
  MESSAGE_SEND: "MESSAGE_SEND",
  MESSAGE_RECEIVE: "MESSAGE_RECEIVE",

  NEW_MESSAGE_SEND: "NEW_MESSAGE_SEND",
  NEW_MESSAGE_RECEIVE: "NEW_MESSAGE_RECEIVE",
  /** search */
  CONTACT_CHAT: "CONTACT_CHAT",
  CONTACT_MESSAGE: "CONTACT_MESSAGE",
  SEARCH_NOTICE: "SEARCH_NOTICE",
  SEARCH_CHAT: "SEARCH_CHAT",
  SEARCH_MESSAGE_SEND: "SEARCH_MESSAGE_SEND",
  SEARCH_MESSAGE_RECEIVE: "SEARCH_MESSAGE_RECEIVE",

  NEW_SEARCH_MESSAGE_SEND: "NEW_SEARCH_MESSAGE_SEND",
  NEW_SEARCH_MESSAGE_RECEIVE: "NEW_SEARCH_MESSAGE_RECEIVE",
  SCHEDULE: "SCHEDULE",
};

export const conversationTypeMap = {
  /** normal */
  ALL: { types: null, isUnread: false, isHost: null, isNotification: false },
  PERSONAL: {
    types: [conversationType.PERSONAL],
    isUnread: false,
    isHost: null,
    isNotification: false,
  },
  CHAT: {
    types: [
      conversationType.GROUP,
      conversationType.PERSONAL,
      conversationType.SELF,
      conversationType.SYSTEM,
    ],
    isUnread: false,
    isHost: null,
    isNotification: false,
  },
  UNREAD: { types: null, isUnread: true, isHost: null, isNotification: false },
  NOTICE: {
    types: [conversationType.NOTIFICATION],
    isHost: null,
    isUnread: false,
    isNotification: true,
  },
  MESSAGE_SEND: {
    types: [conversationType.NOTIFICATION],
    isUnread: false,
    isHost: true,
    isNotification: false,
  },
  MESSAGE_RECEIVE: {
    types: [conversationType.NOTIFICATION],
    isUnread: false,
    isHost: false,
    isNotification: false,
  },

  NEW_MESSAGE_SEND: {
    types: [conversationType.NOTIFICATION],
    isUnread: false,
    isHost: true,
    isNotification: false,
  },
  NEW_MESSAGE_RECEIVE: {
    types: [conversationType.NOTIFICATION],
    isUnread: false,
    isHost: false,
    isNotification: false,
  },
  /** search */
  CONTACT_CHAT: {
    types: [
      conversationType.GROUP,
      conversationType.PERSONAL,
      conversationType.SELF,
      conversationType.SYSTEM,
    ],
    isUnread: false,
    isHost: null,
    searchMemberName: null,
    isNotification: false,
  },
  CONTACT_MESSAGE: {
    types: [conversationType.NOTIFICATION],
    isUnread: false,
    isHost: true,
    isNotification: false,
    searchMemberName: null,
  },
  SEARCH_NOTICE: {
    types: [conversationType.NOTIFICATION],
    isUnread: false,
    isHost: null,
    isNotification: true,
    searchMemberName: null,
  },
  SEARCH_CHAT: {
    types: [
      conversationType.GROUP,
      conversationType.PERSONAL,
      conversationType.SELF,
      conversationType.SYSTEM,
    ],
    isUnread: false,
    isHost: null,
    searchContent: null,
    isNotification: false,
  },
  SEARCH_MESSAGE_SEND: {
    types: [conversationType.NOTIFICATION],
    isUnread: false,
    isHost: true,
    isNotification: false,
    searchContent: null,
  },
  SEARCH_MESSAGE_RECEIVE: {
    types: [conversationType.NOTIFICATION],
    isUnread: false,
    isHost: false,
    isNotification: false,
    searchContent: null,
  },
  NEW_SEARCH_MESSAGE_SEND: {
    types: [conversationType.NOTIFICATION],
    isUnread: false,
    isHost: true,
    isNotification: false,
    searchContent: null,
  },
  NEW_SEARCH_MESSAGE_RECEIVE: {
    types: [conversationType.NOTIFICATION],
    isUnread: false,
    isHost: false,
    isNotification: false,
    searchContent: null,
  },
  SCHEDULE: {
    types: [conversationType.SCHEDULE],
    isUnread: false,
    isHost: false,
    isNotification: false,
    searchContent: null,
  },
};

export const filterTaskByTime = [
  {
    label: "To day",
    value: "TODAY",
  },
  {
    label: "Tomorrow",
    value: "TOMORROW",
  },
  {
    label: "This week",
    value: "THIS_WEEK",
  },
  {
    label: "This month",
    value: "THIS_MONTH",
  },
];
export const filterAlarmByType = [
  {
    label: "All",
    value: "ALL",
  },
  {
    label: "Unread",
    value: "UNREAD",
  },
  {
    label: "read",
    value: "READ",
  },
];

export const filterProjectByType = [
  {
    label: "All",
    value: "ALL",
  },
  {
    label: "Favorites",
    value: "FAVORITES",
  },
  {
    label: "Recently",
    value: "RECENTLY",
  },
];

export const CHATTING = {
  CONVERSATION_LIMIT: 15,
  MESSAGE_LIMIT: 15,
  MEMBER_LIMIT: 15,
};
export const MAIL = {
  TOP_MESSAGE: 10,
  BOTTOM_MESSAGE: 2,
  MORE_MESSAGE: 10,
};
export const PROJECT = {
  PROJECT_LIMIT: 10,
};
export const MY_TASK = {
  MY_TASK_LIMIT: 25,
};
export const ALARM = {
  MY_ALARM_LIMIT: 10,
};
export const STORAGE = {
  STORAGE_LIMIT: 10,
};

export const tabSettings = {
  GENERAL_SETTINGS: "GENERAL_SETTINGS",
  CHANGE_PASSWORD: "CHANGE_PASSWORD",
  PRIVACY: "PRIVACY",
  THEME: "THEME",
  NOTIFICATION: "NOTIFICATION",
  MESSAGE: "MESSAGE",
  UTILITIES: "UTILITIES",
};

export const UNREAD_COUNT_MAX = 10;
export const MAX_CHUNK_LENGTH = 2000;

export const typeConfirms = {
  KICK_MEMBERS: "KICK_MEMBERS",
  UPDATE_ROLE_ADMIN: "UPDATE_ROLE_ADMIN",
  CANCEL_PROJECT: "CANCEL_PROJECT",
  UPDATE_PROJECT: "UPDATE_PROJECT",
  DELETE_PROJECT: "DELETE_PROJECT",
};

export const MENU_WORK_MANAGEMENT = [
  // {
  //   key: "NEW_PROJECT",
  //   name: "New Project +",
  // },
  {
    key: "DASHBOARD",
    name: "Dashboard",
    icon: <MdDashboard size={25} color="#2a56b9" />,
  },
  {
    key: "TASK",
    name: "Task",
    icon: <MdOutlineTaskAlt size={25} color="#36B37E" />,
  },
  {
    key: "ALARM",
    name: "Alarm",
    icon: <MdNotificationsActive size={25} color="#fbbc04" />,
  },
  // {
  //   key: "FILE",
  //   name: "File",
  //   icon: <IoIosFolder size={25} color="#fbbc04" />,
  // },
];

export const MENU_ADMIN_SETTING = [
  {
    key: "USER",
    name: "User",
    icon: <FaUserPen size={25} color="#2a56b9" />,
  },
  {
    key: "ORGANIZATION",
    name: "Organization",
    icon: <RiOrganizationChart size={25} color="#4db74d" />,
  },
  {
    key: "SCHEDULE",
    name: "File",
    icon: <IoIosFolder size={25} color="#fbbc04" />,
  },
  {
    key: "VERSION",
    name: "Version",
    icon: <HiMiniDocumentArrowDown size={29} color="#fb7304ff" />,
  },
  {
    key: "STICKER",
    name: "Sticker Management",
    icon: <StickerIcon width={29} height={29} className="text-[#26b9a6]" />,
  },
  {
    key: "WELCOME",
    name: "Welcome Management",
    icon: (
      <TbDeviceDesktopCog
        className="text-[#26b9a6] w-[29px] h-[29px]"
        color="#ec1f30ff"
      />
    ),
  },
];

export const CODE_TYPE = {
  PROJECT_TYPE: "1001",
  PROGRESS_STEP: "1002",
  ROLE: "1003",
  AUTHORITY: "1004",
  PROPERTY: "1005",
  STAGE_WORKFLOW: "1006",
  WORK_ACTIVITY: "1007",
};

export const WORK_ACTIVITY_CODE = {
  ACTIVITY: "100701",
  ALARM: "100702",
  ISSUE: "100703",
};

export const USAGE_STATUS = {
  YES: "Y",
  NO: "N",
};

export const NOTIFICATION_STATUS = {
  YES: "Y",
  NO: "N",
};

export const TASK_ACTIVITY_TYPE = {
  COMMENT: "C",
  REPLY: "R",
};

export const KEY_MENU_WORK_MANAGEMENT = {
  NEW_PROJECT: "NEW_PROJECT",
  UPDATE_PROJECT: "UPDATE_PROJECT",
  DASHBOARD: "DASHBOARD",
  TIMELINE: "TIMELINE",
  CALENDAR: "CALENDAR",
  TASK: "TASK",
  ALARM: "ALARM",
  FILE: "FILE",
};

export const KEY_MENU_ADMIN_SETTING = {
  SCHEDULE: "SCHEDULE",
  ORGANIZATION: "ORGANIZATION",
  USER: "USER",
  VERSION: "VERSION",
  STICKER: "STICKER",
  WELCOME: "WELCOME",
};

export const AUTHORITY_CONFIG = {
  PROJECT: {
    ID: "M100200",
    LABEL: "Project",
  },
  TASK: {
    ID: "M100300",
    LABEL: "Task",
  },
  PROJECT_MANAGEMENT: {
    ID: "M100100",
    LABEL: "Project Management",
  },
};

export const COMMENT_HISTORY = {
  LIMIT: 10,
};

export const COMMENT = {
  PARENT_LIMIT: 10,
  CHILD_LIMIT: 5,
};

export const tabShareChat = {
  RECENT: "RECENT",
  ORGANIZATION: "ORGANIZATION",
};

export const windowNames = {
  CONVERSATION_LIST: "CONVERSATION_LIST",
  SIDEBAR_CHAT: "SIDEBAR_CHAT",
  CONVERSATION_DETAIL: "CONVERSATION_DETAIL",
  PROJECT_LIST: "PROJECT_LIST",
  PROJECT_DETAIL: "PROJECT_DETAIL",
  TIMELINE: "TIMELINE",
  CALENDAR: "CALENDAR",
  CHAT_MENU: "CHAT_MENU",
  NOTIFICATION_DETAIL: "NOTIFICATION_DETAIL",
};

export const REACTION_TYPE_LABEL = [
  { type: "LIKE", label: "👍" },
  { type: "LOVE", label: "❤" },
  { type: "SMILE", label: "😂" },
  { type: "SAD", label: "😢" },
  { type: "ANGRY", label: "😠" },
];

export const modalTypes = {
  REMOVE_MESSAGE: "REMOVE_MESSAGE",
};

export const ATTRIBUTE_CODE = {
  DATE: "100501",
  DATE_TIME: "100502",
  TEXT: "100503",
};

export const imagesTypes = [
  "image/jpeg",
  "image/png",
  "image/gif",
  "image/bmp",
  "image/webp",
  "image/svg+xml",
  "image/x-icon",
  "image/tiff",
  "image/heic",
  "image/heif",
];

export const deviceTypes = {
  WEB: "WEB",
  ANDROID: "ANDROID",
  IOS: "IOS",
};

export const audioTypes = [
  "mp3",
  "m4a",
  "wav",
  "aac",
  "flac",
  "aiff",
  "ogg",
  "opus",
  "wma",
  "mpeg",
];

export const videoTypes = [
  "mp4",
  "avi",
  "mkv",
  "webm",
  "quicktime",
  "x-flv",
  "x-ms-wmv",
  "mov",
  "3g2",
  "3gp",
  "aaf",
  "asf",
  "avchd",
  "avi",
  "drc",
  "flv",
  "m2v",
  "m3u8",
  "m4p",
  "m4v",
  "mkv",
  "mng",
  "mov",
  "mp2",
  "mp4",
  "mpe",
  "mpg",
  "mpv",
  "mxf",
  "nsv",
  "ogg",
  "ogv",
  "qt",
  "rm",
  "rmvb",
  "roq",
  "svi",
  "vob",
  "webm",
  "wmv",
  "yuv",
];

export const ROLE_TYPE = {
  SYSTEM: "SYSTEM",
  ADMIN: "ADMIN",
  NORMAL: "NORMAL",
};

export const PROJECT_VIEW_MODE = {
  TIMELINE: "TIMELINE",
  DETAIL: "DETAIL",
};

export const MAX_FILE_SIZE = 1024 * 1024 * 1024;
export const CHUNK_SIZE = 500 * 1024;
export const exceedFiles = 24;

export const isAlarmConversationType = (conversation) => {
  return (
    conversation?.type === conversationType.GROUP ||
    conversation?.type === conversationType.SYSTEM ||
    conversation?.type === conversationType.SELF ||
    conversation?.type === conversationType.PERSONAL
  );
};

export const PANEL_STATUS = {
  GROUP_INFO: "GROUP_INFO",
  MEDIA_STORAGE: "MEDIA_STORAGE",
  SEARCH_CHAT: "SEARCH_CHAT",
  SEARCH_CHAT_AFTER_GROUP_INFO: "SEARCH_CHAT_AFTER_GROUP_INFO",
};

export const eventBusType = {
  USER_DETAIL_UPDATED: "USER_DETAIL_UPDATED",
  USER_LIST_UPDATED: "USER_LIST_UPDATED",

  /** search */
  SEARCH_CHAT: "SEARCH_CHAT",

  /** side bar feature */
  CONVERSATION: "CONVERSATION",

  /** download */
  IDLE: "IDLE",
  STARTING: "STARTING",
  DOWNLOADING: "DOWNLOADING",
  PAUSED: "PAUSED",
  SUCCESS: "SUCCESS",
  ERROR: "ERROR",

  /* upload */
  FILE: "FILE",
  IMAGE: "IMAGE",
};

export const SupportTypePreviewOfficeFile = {
  excelTypes: [
    "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
    "application/vnd.ms-excel", // .xls
    "text/csv",
  ],
  documentTypes: [
    "application/pdf", // .pdf gốc
    "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
    "application/msword", // .doc
    "application/vnd.openxmlformats-officedocument.presentationml.presentation", // .pptx
    "application/vnd.ms-powerpoint", // .ppt
    "application/vnd.oasis.opendocument.text", // .odt
    "application/vnd.oasis.opendocument.spreadsheet", // .ods
    "application/vnd.oasis.opendocument.presentation", // .odp
    "application/rtf", // .rtf
    "text/rtf", // .rtf
    "application/x-hwp",
    "application/haansofthwp",
    "application/vnd.hancom.hwp",
  ],
  textTypes: ["application/json", "application/xml"],
};

export const SupportTypeExtensionOfficeFile = {
  excelTypes: [
    "xlsx", // .xlsx
    "xls", // .xls
    "csv",
  ],
  documentTypes: [
    "pdf", // .pdf gốc
    "docx", // .docx
    "doc", // .doc
    "pptx", // .pptx
    "ppt", // .ppt
    "odt", // .odt
    "ods", // .ods
    "odp", // .odp
    "rtf", // .rtf
    "hwp",
  ],
  textTypes: ["txt", "json", "xml"],
};
